export const menuItems = [
    { path: 'Living', label: 'Living Wall' },
    { path: 'Solution', label: 'Solution' },
    { path: 'Process', label: 'Process' },
    { path: 'About', label: 'About' },
    { path: 'Connect', label: 'Connect' },
];

export const footernav = [
    { path: 'Living', label: 'Living Wall' },
    { path: 'Solution', label: 'Solution' },
    { path: 'Services', label: 'Services' },
    { path: 'About', label: 'About' },
];



















